import { render } from "./ViewerForm.vue?vue&type=template&id=16b0bb98"
import script from "./ViewerForm.vue?vue&type=script&lang=js"
export * from "./ViewerForm.vue?vue&type=script&lang=js"
script.render = render

export default script